import React from 'react'
import PropTypes from 'prop-types'

function TextArea({ label, name, value, onChange }) {
    return (
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-blue focus:border-primary-blue sm:text-sm"
                rows={4}
            />
        </div>
    );
}

TextArea.defaultProps = {
    label: 'Message',
    name: 'message',
    value: ''
}

TextArea.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string
}

export default TextArea